import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  { path: 'login', redirectTo: 'auth/login', pathMatch: 'full' },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./features/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'acoes-judiciais',
    loadChildren: () => import('./features/acoes-judiciais/acoes-judiciais.module').then(m => m.AcoesJudiciaisModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'solicitacoes',
    loadChildren: () => import('./features/solicitacoes/solicitacoes.module').then(m => m.SolicitacoesModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'caixa-entrada',
    loadComponent: () =>
      import('./features/distribuicoes/caixa-entrada/caixa-entrada.component')
        .then(m => m.CaixaEntradaComponent),
    canActivate: [AuthGuard]
  },
  {
    path: 'relatorios',
    loadChildren: () => import('./features/relatorios/relatorios.module').then(m => m.RelatoriosModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'ocorrencias',
    loadChildren: () => import('./features/ocorrencias/ocorrencias.module').then(m => m.OcorrenciasModule)
  },
  {
    path: 'vinculos-email-unidade',
    loadChildren: () => import('./features/vinculos-email-unidade/vinculos-email-unidade.module').then(m => m.VinculosEmailUnidadeModule),
    canActivate: [AuthGuard]
  },
  { path: '**', redirectTo: 'dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}